var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22218(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22218",
    "data-name": "Group 22218",
    transform: "translate(-252 -749)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5784",
    "data-name": "Rectangle 5784",
    width: 44,
    height: 44,
    rx: 5,
    transform: "translate(252 749)",
    fill: "#efebff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_21",
    "data-name": "Layer 21",
    transform: "translate(259.422 756.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27644",
    "data-name": "Path 27644",
    d: "M14.577,27.443a2.644,2.644,0,0,1-1.948-.881C9.412,23.036,4,16.328,4,11.895A10.745,10.745,0,0,1,14.577,1,10.745,10.745,0,0,1,25.154,11.895c0,4.407-5.412,11.1-8.629,14.676A2.644,2.644,0,0,1,14.577,27.443Zm0-24.68a8.991,8.991,0,0,0-8.814,9.132c0,2.768,3.059,7.81,8.18,13.495a.881.881,0,0,0,1.269,0c5.121-5.685,8.18-10.727,8.18-13.495a8.991,8.991,0,0,0-8.814-9.132Z",
    fill: "#6d4eec",
    stroke: "#6d4eec",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27645",
    "data-name": "Path 27645",
    d: "M15.289,17.577a5.289,5.289,0,1,1,5.289-5.289A5.289,5.289,0,0,1,15.289,17.577Zm0-8.814a3.526,3.526,0,1,0,3.526,3.526A3.526,3.526,0,0,0,15.289,8.763Z",
    transform: "translate(-0.711 -0.711)",
    fill: "#6d4eec",
    stroke: "#6d4eec",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22218);
export default __webpack_public_path__ + "static/media/Group 22218.1b73ca7e572f5e176ce600c452ad7513.svg";
export { ForwardRef as ReactComponent };